import { Skeleton } from 'antd';
import * as Styled from './styles';
import { IS_DEFAULT_MODE } from 'constants/app/configs';

export const UserPanelWebViewSkeleton = () => {
  return (
    <Styled.Wrapper>
      {IS_DEFAULT_MODE && (
        <Styled.WalletInfo>
          <Styled.Username>
            <Skeleton.Button
              active
              style={{
                height: 15,
                width: 60,
                minWidth: 60,
                margin: 0
              }}
            />
          </Styled.Username>
          <Styled.Balance>
            <Skeleton.Button
              active
              style={{
                height: 15,
                width: 40,
                minWidth: 40,
                margin: 0
              }}
            />
          </Styled.Balance>
        </Styled.WalletInfo>
      )}
      <Skeleton.Avatar active size={32} />
      <Skeleton.Button
        active
        style={{
          height: 14,
          width: 16,
          minWidth: 16,
          margin: 0
        }}
      />
    </Styled.Wrapper>
  );
};
